module.exports = __webpack_public_path__ + "static/media/activate-card-sample.b4b25065.csv";